import Vue from 'vue'
import applyHeard from "./applyHeard.vue";
import applyBottom from "./applyBottom.vue";
import menu from "./menu.vue"
import bottommenu from "@/components/bottommenu.vue"
import secondarymenu from "@/components/secondarymenu.vue"
import applymenu from "@/components/applymenu.vue"

Vue.component('bottommenu', bottommenu)
Vue.component('mymenu', menu)
Vue.component('secondarymenu', secondarymenu)
Vue.component('applymenu', applymenu)

Vue.component('applyHeard', applyHeard)

Vue.component('applyBottom', applyBottom)